import { observer } from 'mobx-react-lite';
import { DiagnosticsLogger } from '../store/schema/DiagnosticsLogState';
import { customRenderPanelMap } from '../actions/registerDiagnostics';

export interface CustomDiagnosticsPanelProps {
    logger: DiagnosticsLogger<any>;
}

const CustomDiagnosticsPanel = observer(function CustomDiagnosticsPanel(
    props: CustomDiagnosticsPanelProps
) {
    return customRenderPanelMap[props.logger.name]();
});
export default CustomDiagnosticsPanel;
